import { render } from "./FileUploadCom.vue?vue&type=template&id=a086770c&scoped=true"
import script from "./FileUploadCom.vue?vue&type=script&lang=js"
export * from "./FileUploadCom.vue?vue&type=script&lang=js"

import "./FileUploadCom.vue?vue&type=style&index=0&id=a086770c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a086770c"]])

export default __exports__